'use client'
import { FC } from 'react'
import { Button } from 'design-system'

import config from 'config'
import { NetworkBasicInfo } from './types'

interface SelectedNetworkButtonProps {
  selectedNetwork?: NetworkBasicInfo | null
}

export const SelectedNetworkContinueButton: FC<SelectedNetworkButtonProps> = ({
  selectedNetwork
}) => {
  const handleContinue = () => {
    if (!selectedNetwork) return
    const url = `${config.NEXT_PUBLIC_API_URL}/auth/saml/gen-auth-request?networkName=${selectedNetwork.name}`
    window.location.href = url
  }

  return (
    <Button onClick={handleContinue} disabled={!selectedNetwork}>
      Continue
    </Button>
  )
}
